import { render } from "./VdhLogo.vue?vue&type=template&id=028d70de"
import script from "./VdhLogo.vue?vue&type=script&lang=js"
export * from "./VdhLogo.vue?vue&type=script&lang=js"

import "./VdhLogo.vue?vue&type=style&index=0&id=028d70de&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__